<div class="home-page">
    <div class="home-shell">
        <header class="home-header" [ngStyle]="{ 'background-image': headerBackground() }">
            <div class="home-header__intro">
                <h1 class="home-header__title">{{ welcomePhrase }}</h1>
            </div>

            <div class="home-header__actions">
                <button
                    type="button"
                    class="fo-btn fo-btn--ghost home-header__info"
                    title="Browser supportati"
                    aria-label="Browser supportati"
                    (click)="openBrowserInfo()"
                >
                    <i class="material-icons">info</i>
                </button>
                <button
                    type="button"
                    class="fo-btn fo-btn--ghost"
                    (click)="edit_profile()"
                >
                    Modifica profilo
                </button>
                <button
                    type="button"
                    class="fo-btn fo-btn--danger"
                    (click)="logout()"
                >
                    Esci
                </button>
            </div>
        </header>

        <section
            class="fo-card home-card home-card--confirm"
            *ngIf="askUserDataConfirmation"
        >
            <div class="home-card__body home-confirm">
                <span class="home-confirm__icon">
                    <mat-icon>edit</mat-icon>
                </span>
                <h2 class="home-card__title">
                    Conferma i tuoi dati anagrafici.
                </h2>
            </div>
            <div class="home-card__foot">
                <button
                    type="button"
                    class="fo-btn fo-btn--primary fo-btn--block"
                    (click)="edit_profile()"
                >
                    Procedi
                </button>
            </div>
        </section>

        <section
            class="fo-card home-card home-card--appointments"
            *ngIf="ticketServices && hasScheduledService"
        >
            <div class="home-card__head">
                <h2 class="home-card__title">Appuntamenti di oggi</h2>
            </div>
            <div class="home-card__body home-appointments">
                <app-appointments [dataSource]="dataSource"></app-appointments>
            </div>
            <div class="home-card__foot home-card__foot--split">
                <button
                    type="button"
                    class="fo-btn fo-btn--ghost"
                    (click)="seeAllTicket()"
                >
                    Visualizza tutti
                </button>
            </div>
        </section>

        <div
            *ngIf="!askUserDataConfirmation"
            class="home-services"
            [ngClass]="{ onlyOneCard: activeServices?.length === 1 }"
        >
            <ng-container *ngFor="let service of activeServices">
                <article
                    class="fo-card service-card"
                    *ngIf="ticketServices && ticketServices[service.service]"
                    [style.--ch]="ticketServices[service.service].color"
                >
                    <span class="service-card__accent"></span>

                    <div class="service-card__head">
                        <span class="service-card__icon">
                            <mat-icon
                                *ngIf="ticketServices[service.service]?.webIcon"
                                >{{
                                    ticketServices[service.service]?.webIcon
                                }}</mat-icon
                            >
                        </span>

                        <span
                            *ngIf="isOpen(service.service); else chatElseBlock"
                            class="fo-chip fo-chip--on is-open"
                        >
                            Aperto
                        </span>
                        <ng-template #chatElseBlock>
                            <span class="fo-chip fo-chip--off is-closed">
                                Chiuso
                            </span>
                        </ng-template>
                    </div>

                    <div class="service-card__body">
                        <h2 class="service-card__title">
                            {{ ticketServices[service.service]?.title }}
                        </h2>
                        <div
                            *ngIf="!!ticketServices"
                            class="service_description"
                            [innerHTML]="
                                ticketServices[service.service].description
                            "
                        ></div>
                    </div>

                    <div class="service-card__foot">
                        <button
                            type="button"
                            class="fo-btn fo-btn--primary fo-btn--block service-card__cta"
                            [ngClass]="{
                                'service-close': !isOpen(service.service),
                                'service-pending': serviceRequestInProgress
                            }"
                            (click)="clickService(service)"
                        >
                            <span *ngIf="service.type !== 'scheduled'"
                                >Procedi</span
                            >
                            <span *ngIf="service.type === 'scheduled'"
                                >Richiedi Appuntamento Programmato</span
                            >
                        </button>
                    </div>
                </article>
            </ng-container>
        </div>
    </div>
</div>
